import React, { useEffect, useState } from "react";
import "./CurrentOpeningsForm.css";
// import BASE_URL from '../../config';

import {
  BASE_URL,
  GET_CURRENT_OPENINGS_URL,
  ADD_UPDATE_CURRENT_OPENINGS,
  DELETE_CURRENT_OPENINGS,
} from "../../constants/Apis";

const CurrentOpeningsForm = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editingIndex, setEditingIndex] = useState(null);
const [newJob, setNewJob] = useState({
  id: Math.floor(100000 + Math.random() * 900000), // 👈 unique random 6-digit ID
  icon: "",
  title: "",
  jobtype: "",
  address: "",
  description: "",
  chips: [],
  enabled: false,
});

  const fetchConfig = () => {
    setLoading(true);
    fetch(`${BASE_URL}${GET_CURRENT_OPENINGS_URL}`)
      .then((res) => res.json())
      .then((data) => {
        setConfig(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (!config) return <p>Failed to load open positions config</p>;

  const handleItemChange = (index, field, value) => {
    const updated = [...config.items];
    if (field === "chips") {
      updated[index][field] = value.split(",").map((c) => c.trim());
    } else {
      updated[index][field] = value;
    }
    const updatedConfig = { ...config, items: updated };
    setConfig(updatedConfig);

    // console.log("Added Data->", JSON.stringify(updatedConfig));
    // Update API immediately
    fetch(`${BASE_URL}${ADD_UPDATE_CURRENT_OPENINGS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedConfig),
    })
      .then((res) => res.json())
      .catch((err) => console.error(err));
  };

  const handleDelete = (index) => {
    fetch(`${BASE_URL}${DELETE_CURRENT_OPENINGS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ index }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          alert("Job opening deleted successfully");
          fetchConfig();
        } else {
          alert(data.message || "Failed to delete job");
        }
      })
      .catch((err) => console.error(err));
  };

  const handleAddJob = () => {
  if (!newJob.title.trim()) {
    alert("Title is required");
    return;
  }

  const updatedConfig = { ...config, items: [...config.items, newJob] };

  fetch(`${BASE_URL}${ADD_UPDATE_CURRENT_OPENINGS}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updatedConfig),
  })
    .then((res) => res.json())
    .then(() => {
      setConfig(updatedConfig);
      setNewJob({
        id: Math.floor(100000 + Math.random() * 900000), // 👈 regenerate ID
        icon: "",
        title: "",
        jobtype: "",
        address: "",
        description: "",
        chips: [],
        enabled: false,
      });
    })
    .catch((err) => console.error(err));
};

  return (
    <div className="open-positions-form">
      <h2>Current Open Positions Config</h2>

      <h3>Job Positions</h3>

      {/* Add new job form */}
      <div className="job-add-card">
        <h4>Add New Job</h4>
        <input
          type="text"
          placeholder="Job Title"
          value={newJob.title}
          onChange={(e) => setNewJob({ ...newJob, title: e.target.value })}
        />
        <input
          type="text"
          placeholder="Job Type"
          value={newJob.jobtype}
          onChange={(e) => setNewJob({ ...newJob, jobtype: e.target.value })}
        />
        <input
          type="text"
          placeholder="Address"
          value={newJob.address}
          onChange={(e) => setNewJob({ ...newJob, address: e.target.value })}
        />
        <textarea
          placeholder="Description"
          value={newJob.description}
          onChange={(e) => setNewJob({ ...newJob, description: e.target.value })}
        />
        <input
          type="text"
          placeholder="Chips (comma separated)"
          value={newJob.chips.join(", ")}
          onChange={(e) =>
            setNewJob({
              ...newJob,
              chips: e.target.value.split(",").map((c) => c.trim()),
            })
          }
        />
        <button onClick={handleAddJob}>Add Job</button>
      </div>

      {/* Job list */}
      <div className="job-list">
        {config.items.map((item, idx) => (
          <div key={idx} className="job-card">
            {item.icon && <img src={item.icon} alt="" className="job-icon" />}
            <div className="job-details">
              <h4>{item.title}</h4>
              <p><strong>Type:</strong> {item.jobtype}</p>
              <p><strong>Location:</strong> {item.address}</p>
              <p><strong>Description:</strong> {item.description}</p>
              <div className="job-chips">
                {item.chips.map((chip, i) => (
                  <span key={i} className="chip">{chip}</span>
                ))}
              </div>
              <p><strong>Status:</strong> {item.enabled ? "Enabled ✅" : "Disabled ❌"}</p>
            </div>
            <div className="job-actions">
              <button onClick={() => setEditingIndex(idx)}>Edit</button>
              <button onClick={() => handleDelete(idx)}>Remove</button>
            </div>
          </div>
        ))}
      </div>

      {/* Edit form for selected job */}
      {editingIndex !== null && (
        <div className="job-edit-card">
          <h4>Edit Job</h4>
          <label>Title</label>
          <input
            type="text"
            value={config.items[editingIndex].title}
            onChange={(e) =>
              handleItemChange(editingIndex, "title", e.target.value)
            }
          />
          <label>Job Type</label>
          <input
            type="text"
            value={config.items[editingIndex].jobtype}
            onChange={(e) =>
              handleItemChange(editingIndex, "jobtype", e.target.value)
            }
          />
          <label>Address</label>
          <input
            type="text"
            value={config.items[editingIndex].address}
            onChange={(e) =>
              handleItemChange(editingIndex, "address", e.target.value)
            }
          />
          <label>Description</label>
          <textarea
            value={config.items[editingIndex].description}
            onChange={(e) =>
              handleItemChange(editingIndex, "description", e.target.value)
            }
          />
          <label>Chips</label>
          <input
            type="text"
            value={config.items[editingIndex].chips.join(", ")}
            onChange={(e) =>
              handleItemChange(editingIndex, "chips", e.target.value)
            }
          />
          <label>Enabled</label>
          <input
            type="checkbox"
            checked={config.items[editingIndex].enabled}
            onChange={(e) =>
              handleItemChange(editingIndex, "enabled", e.target.checked)
            }
          />
          <button onClick={() => setEditingIndex(null)}>Done</button>
        </div>
      )}
    </div>
  );
};

export default CurrentOpeningsForm;